<!-- @format -->

@if (assessmentItem) {
  <h5 class="sis-mt-sm">{{ assessmentItem.name | localizedString }} ({{ assessmentItem.credits | creditRange: "SYMBOLS" }})</h5>
  @if (!courseUnitRealisations?.length) {
    <p class="sis-guidance">
      {{ "OPEN_UNIVERSITY.STUDY_OFFERING.ASSESSMENT_ITEM.NO_CURS" | translate }}
    </p>
  }
  @if (courseUnitRealisations?.length > 1 && !hideGuidance) {
    <p class="sis-guidance">
      {{ "OPEN_UNIVERSITY.STUDY_OFFERING.ASSESSMENT_ITEM.SEVERAL_CURS" | translate }}
    </p>
  }
  @for (courseUnitRealisation of courseUnitRealisations; track entityId($index, courseUnitRealisation)) {
    <sis-expandable
      (closedChange)="closedChange(courseUnitRealisation, $event)"
      [title]="(courseUnitRealisation.name | localizedString) + ' ' + (courseUnitRealisation.activityPeriod | localDateRange)"
      [variant]="'naked-dotted'"
      [level]="6"
      [closed]="isClosed(courseUnitRealisation) | async"
      [elementId]="getCourseUnitRealisationElementId(courseUnitRealisation)">
      @if (seatCounts) {
        @if (curIsFull(courseUnitRealisation)) {
          <ng-template sisExpandableCustomTitle>
            <sis-tiny-badge variant="danger">{{ "OPEN_UNIVERSITY.STUDY_OFFERING.ASSESSMENT_ITEM.CUR_FULL" | translate }}</sis-tiny-badge>
          </ng-template>
        }
      }
      <ng-template sisExpandableContent>
        <app-open-university-course-unit-realisation-info
          [courseUnitRealisation]="courseUnitRealisation"
          [courseUnitId]="courseUnitId"
          [hideGuidance]="hideGuidance"></app-open-university-course-unit-realisation-info>
      </ng-template>
    </sis-expandable>
  }
}
